var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show === true)?_c('smallModal',{on:{"escape":_vm.close}},[_c('companyList',{attrs:{"data":_vm.data},on:{"goToCompany":_vm.goToCompany,"logout":_vm.logout}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }